// IMPORTS
import { ref, computed } from 'vue'
import { store } from '../../store/store';

/**
 * Exporting "default" so that the import doesn't have to be named in other components.
 * To create named and/or multiple exports, use: export cont compName = {}
 * Remember to import any reactive features from 'vue' if you need reactivity (e.g. computed, ref, reactive, etc.)
 */
export default {
    /* Name the component for easy reference */
    name: 'CountDownDisplay',

    /* Any imported component for this file needs to be listed here */
    components: {
        
    },

    /* Declare any expected props here */
    props: {
        cdClass: {
            type: String,
            required: true
        },
        slotData: {
            type: Object,
            required: true
        }
    },

    /* All component logic goes here in setup(). Anything complex or verbose should be handled in an external file,
        using this as more of a "controller" for the component.
    */
    setup(props) {
        let displayText = '';

        const gt1d_text = computed(() => {
            const displayText = store.time.getCountDownDisplayText(props.slotData, ['days', 'hours']);

            return displayText;
        });

        const lt1d_gt1h_text = computed(() => {
            const displayText = store.time.getCountDownDisplayText(props.slotData, ['hours', 'minutes']);

            return displayText;
        });

        const lt1h_gt1m_text = computed(() => {
            const displayText = store.time.getCountDownDisplayText(props.slotData, ['minutes', 'seconds']);

            return displayText;
        });

        const lt1m_gt0s_text = computed(() => {
            const displayText = store.time.getCountDownDisplayText(props.slotData, ['seconds']);

            return displayText;
        });

        function generateDisplayText(cdClass, slotData) {
            switch(cdClass) {
                case 'gt1d':
                    displayText = gt1d_text;
                    break;

                case 'lt1d_gt1h':
                    displayText = lt1d_gt1h_text;
                    break;

                case 'lt1h_gt1m':
                    displayText = lt1h_gt1m_text;
                    break;

                case 'lt1m_gt0s':
                    displayText = lt1m_gt0s_text;
                    break;

                default:
                    break;
            }
        }
        generateDisplayText(props.cdClass, props.slotData);

        /* We need to return any variables/functions that we want to use in our template below. */
        return {
            props,
            displayText
        }
    },

    /* Define the template that will be displayed for this component (optional) */
    template: /*html*/`
        <div class="cfm_ec_countdown_display">
            
            <div
            class="countDownText"
            :class="cdClass"
            v-html="displayText"
            ></div>

        </div>
    `,
}